import apiClient from './client';
import type {
  ProviderFinanceAlertSettings,
  ProviderFinanceAlertSettingsUpdate,
  ProviderFinanceDashboard,
  ProviderFinanceDashboardParams,
  ProviderFinanceSyncRequest,
  ProviderFinanceSyncResponse,
} from '@/types/providerFinance';

export const providerFinanceApi = {
  getDashboard: (params: ProviderFinanceDashboardParams | string = { range: '30d' }) => {
    const query =
      typeof params === 'string'
        ? { range: params }
        : {
            ...(params.range ? { range: params.range } : {}),
            ...(params.start_date ? { start_date: params.start_date } : {}),
            ...(params.end_date ? { end_date: params.end_date } : {}),
          };
    return apiClient
      .get<ProviderFinanceDashboard>('/provider-finance/dashboard', { params: query })
      .then((r) => r.data);
  },

  getAlertSettings: (accountId: string) =>
    apiClient
      .get<ProviderFinanceAlertSettings | null>(
        `/provider-finance/accounts/${encodeURIComponent(accountId)}/alert-settings`,
      )
      .then((r) => r.data),

  putAlertSettings: (accountId: string, body: ProviderFinanceAlertSettingsUpdate) =>
    apiClient
      .put<ProviderFinanceAlertSettings>(
        `/provider-finance/accounts/${encodeURIComponent(accountId)}/alert-settings`,
        body,
      )
      .then((r) => r.data),

  triggerSync: (payload: ProviderFinanceSyncRequest = {}) =>
    apiClient
      .post<ProviderFinanceSyncResponse>('/provider-finance/sync', payload)
      .then((r) => r.data),
};
